import apiClient from "../api/client";

const getApiBase = () => {
  return sessionStorage.getItem("API_BASE_URL") || '';
};

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const getExternalImports = async (reportType) => {
  try {
   const res = await apiClient.get(`/api/externalimport?reportType=${reportType}`);
    return res.data || [];
  } catch (err) {
    console.error('getExternalImports error:', err);
    throw err;
  }
};

export const getExternalLogs = async (id, reportType, page = 1, pageSize = 10) => {
  try {
    const res = await apiClient.get(`/api/externalimport/logs?id=${id}&reportType=${reportType}&page=${page}&pageSize=${pageSize}`);
    return res.data || [];
  } catch (err) {
    console.error('getExternalLogs error:', err);
    throw err;
  }
};

export const uploadExternalFile = async (file, reportType, userId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('reportType', reportType);
  formData.append('userId', userId);
  const currentDomain = sessionStorage.getItem("selectedDomain");
  formData.append('domain', currentDomain);

  try {
        // const res = await axios.post('https://localhost:7053/api/externalimport/upload', formData, {
    const res = await apiClient.post(`/api/externalimport/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (err) {
    console.error('uploadExternalFile error:', err);
    throw err;
  }
};